import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { useGetClickHandlers } from '../DocFlowProfileHeaderActions.hooks'

function ArchiveButton({
  className,
  disabled,
  text = 'DocFlow.ProfileArchiveBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleClickArchive } = useGetClickHandlers(restProps)

  return (
    <Button.Outlined
      className={className}
      disabled={disabled}
      text={t(text)}
      onClick={handleClickArchive}
    />
  )
}

export default ArchiveButton
